import { OrderForm } from "../../components/order";

export function SupplierSalesNew() {
  return <OrderForm mode="create" side="supplier" />;
}
